// iot-admin/client/src/components/DeviceDocImage.js
// Reusable image-field building blocks for device documents.
// - ImageField: presentational thumbnail + upload/replace control.
// - DeviceDocImage: self-contained device-level doc upload (presign → PUT →
//   save the key onto the edge_nodes_devices column via deviceService).

import React, { useState } from 'react';
import { deviceService } from '../services/api';
import './DeviceSimTaxiDriver.css';

/* thumbnail + upload/replace control */
export const ImageField = ({ label, url, uploading, onUpload, size }) => (
  <div className={`std-image-field ${size === 'sm' ? 'std-image-field--sm' : ''}`}>
    <label className="std-image-label">{label}</label>
    {url ? (
      <a href={url} target="_blank" rel="noopener noreferrer" className="std-thumb">
        <img src={url} alt={label} />
      </a>
    ) : (
      <div className="std-thumb std-thumb--empty">No image</div>
    )}
    <label className={`btn btn-secondary btn-sm std-upload-btn ${uploading ? 'is-disabled' : ''}`}>
      {uploading ? 'Uploading…' : url ? 'Replace' : 'Upload'}
      <input
        type="file"
        accept="image/*"
        hidden
        disabled={uploading}
        onChange={(e) => { if (e.target.files?.[0]) onUpload(e.target.files[0]); e.target.value = ''; }}
      />
    </label>
  </div>
);

/* device-level document image (persists to an edge_nodes_devices column) */
export const DeviceDocImage = ({ deviceId, docType, label, url, onDone, onMessage, onError, size }) => {
  const [uploading, setUploading] = useState(false);
  const handle = async (file) => {
    setUploading(true);
    try {
      const key = await deviceService.uploadDocument(deviceId, docType, file);
      await deviceService.saveDocument(deviceId, docType, key);
      onMessage && onMessage('Image uploaded');
      onDone && (await onDone());
    } catch (e) {
      onError && onError(e.response?.data?.error || e.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };
  return <ImageField label={label} url={url} uploading={uploading} onUpload={handle} size={size} />;
};

export default DeviceDocImage;
